import { useState, useEffect } from 'react'
import { toast } from 'sonner'

export interface VersionInfo {
  version: string
  displayName: string
  releaseDate: string
  agentType: string
}

export interface AgentVersions {
  hr?: VersionInfo
  ops?: VersionInfo
}

export const useAgentVersions = () => {
  const [versions, setVersions] = useState<AgentVersions>({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchVersions = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const response = await fetch('/api/agents/versions/current')
      
      if (!response.ok) {
        throw new Error(`Failed to fetch versions: ${response.statusText}`)
      }
      
      const data = await response.json()
      console.log('🔍 Raw API response:', data)
      
      // Transform the response to match our interface
      const transformedVersions: AgentVersions = {}
      
      if (data.versions.hr) {
        transformedVersions.hr = {
          version: data.versions.hr.version,
          displayName: data.versions.hr.displayName,
          releaseDate: data.versions.hr.releaseDate,
          agentType: 'HR'
        }
      }
      
      if (data.versions.ops) {
        transformedVersions.ops = {
          version: data.versions.ops.version,
          displayName: data.versions.ops.displayName,
          releaseDate: data.versions.ops.releaseDate,
          agentType: 'OPS'
        }
      }
      
      setVersions(transformedVersions)
      console.log('🎯 Transformed versions:', transformedVersions)
    } catch (err) {
      console.error('Error fetching agent versions:', err)
      setError(err instanceof Error ? err.message : 'Failed to load versions')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchVersions()
  }, [])

  const refetchVersions = () => {
    fetchVersions()
  }

  return {
    versions,
    loading,
    error,
    refetchVersions
  }
}